import { FontEntry } from '../../types/font'

export const austinNewsDeck: FontEntry = {
  displayName: 'austin-news-deck',
  weights: {
    400: {
      normal: { file: 'AustinNewsDeck-Regular', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    500: {
      normal: null,
      italic: { file: 'AustinNewsDeck-MediumItalic', extension: 'woff2', format: 'woff2' }
    },
    600: {
      normal: { file: 'AustinNewsDeck-SemiBold', extension: 'woff2', format: 'woff2' },
      italic: null
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 93.51,
        ascentOverride: 99.46,
        descentOverride: 26.74,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 94.12,
        ascentOverride: 98.81,
        descentOverride: 26.56,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 94.87,
        ascentOverride: 98.02,
        descentOverride: 26.35,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 99.71,
        ascentOverride: 93.27,
        descentOverride: 25.07,
        lineGapOverride: 0
      }
    }
  }
}
